import { render, staticRenderFns } from "./layinka_yusuf_AjTeam.vue?vue&type=template&id=d87775bc&scoped=true&"
import script from "./layinka_yusuf_AjTeam.vue?vue&type=script&lang=js&"
export * from "./layinka_yusuf_AjTeam.vue?vue&type=script&lang=js&"
import style0 from "./layinka_yusuf_AjTeam.vue?vue&type=style&index=0&id=d87775bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87775bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
